/* Lightweight client helper to record a step in the user's IPO journey audit
 * trail. Fire-and-forget — never blocks the UI. The backend de-dupes repeated
 * identical steps so navigating back and forth doesn't flood the log. */
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const logJourney = (module, action = "Viewed", detail = "") => {
  try {
    fetch(`${API_URL}/api/workspace/audit-log/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ module, action, detail }),
    }).catch(() => {});
  } catch {
    /* ignore — auditing must never break the app */
  }
};

export default logJourney;
